<template lang="pug">
    div.dataFlow(:class="{up: up, down: down}")

        // Value
        div.dataValue {{ dataValue }}

        // Icon marker
        div
            v-icon(v-if="up" color="success") trending_up
            v-icon(v-if="down" color="red") trending_down
            v-icon(v-if="isEqual" color="primary") trending_flat
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            dataValue: VueTypes.number.def(0),
        },
        data() {
            return {
                up: false,
                down: false,
                isEqual: false,
            };
        },
        watch: {
            dataValue(val, oldVal) {
                switch (true) {
                    case !oldVal:
                        this.up = false;
                        this.down = false;
                        this.isEqual = false;
                        break;

                    case val > oldVal:
                        this.up = true;
                        this.down = false;
                        this.isEqual = false;
                        break;

                    case val < oldVal:
                        this.up = false;
                        this.down = true;
                        this.isEqual = false;
                        break;

                    default:
                        this.up = false;
                        this.down = false;
                        this.isEqual = true;
                }
            },
        },
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'
    .dataFlow
        display: flex
        justify-content: flex-end
        align-items: center

    .up
        color: $theme.success

    .down
        color: $theme.urgent

    .dataValue
        font-weight: 700
        font-size: 16px
</style>
